import { mapGetters } from 'vuex';

export default {
    name: 'guideHubSideContent',
    props: ['hubItems', 'contentType', 'geo' ],

    data(){
        return {
            title:'',
            hubUrl:'',
            subText:'',
            itemsList: [],
            slicedList: [],
            maxItems: 2,
            twoCols: false,
            appUrl:'',
            showAll: false
        };
    },
    methods:{
        toggle(flag) {
            this.showAll = flag;
            if (this.showAll) {
                this.slicedList = this.itemsList;
            } else {
                this.slicedList = this.itemsList && this.itemsList.slice(0, this.maxItems);
            }
        }
    },
    mounted() {
        if(this.hubItems){
             this.itemsList = this.hubItems;
        }
        this.appUrl = this.glb.appUrl;
        const isCity = this.geo.geoType === 'CITY';
        const hubName = this.geo.neighborhood || this.geo.city || '';
        const msp = this.geo.neighborhoodPath || isCity && this.geo.cityPath;
        switch(this.contentType){
            case 'HomesForSale':
                this.subText = 'Property';
                if(isCity) {
                    this.title = `Homes for Sale ${hubName}, ${this.geo.state}`;
                    this.urlKey = 'sitemapCityPropertyPageUrl';
                } else {
                    this.title = 'Homes for Sale Nearby ' + hubName;
                    this.urlKey = 'sitemapNeighborhoodPageUrl';
                }
                break;
            case 'ZipCode':
                this.title = `Properties within Zip Codes ${hubName}, ${this.geo.state}`;
                this.twoCols = true;
                this.maxItems = 4;
                this.urlKey = 'sitemapZipCodePageUrl';
                break;
            case 'Neighbourhood':
                this.subText = 'Property';
                this.title = `Neighborhoods in ${hubName}, ${this.geo.state}`;
                this.urlKey = 'sitemapNeighborhoodPageUrl';
                break;
            case 'RealEstateLinks':
                this.appUrl = '';
                this.title = `${hubName}, ${this.geo.state} Real Estate Links`;
                this.urlKey = 'url';
                this.itemsList.push({
                    url: this.getHubLinks.base, displayName: hubName + ' Mapsearch'},
                    {url: this.getHubLinks.filteredUrlObj.openHouse, displayName: hubName + ' Open Houses'},
                    {url: this.getHubLinks.filteredUrlObj.new, displayName: hubName + ' New Homes'
                });
                msp && this.itemsList.push({url: this.glb.appUrl + msp + 'market-trends/', displayName: hubName + ' Market Trends'});
                this.itemsList.push({url: this.getHubLinks.sold, displayName: hubName + ' Sold Homes'});
                break;
        }
        this.toggle(0);
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        getHubLinks() {
            return this.generateMapSearchUrl(this.glb.appUrl, {
                type: this.geo.geoType,
                cityName: this.geo.city,
                stateCode: this.geo.stateCode,
                neighborhood: this.geo.neighborhood,
                rentals: this.glb.rentals,
                filterArray: ['openHouse', 'new']
            });
        }
    }
};